import { Autocomplete, TextField } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import * as React from "react";
import { QueryFilter } from "./Interface.helper";

interface ComboBoxQueryParams {
  queryFilter: QueryFilter[];
  defaultValue?: QueryFilter[];
  selectedValues: (e: any) => void;
}

const ComboBoxQuery: React.FC<ComboBoxQueryParams> = ({
  queryFilter,
  selectedValues,
  defaultValue,
}) => {
  const [_, setSelectedOptions] = React.useState<any[]>([]);

  const handleChange = (newValue: any) => {
    setSelectedOptions(newValue);
    selectedValues(newValue);
  };

  React.useEffect(() => {
    //TODO fix  , broken set filter from url param
    //selectedValues(defaultValue);
  }, [defaultValue]);

  return (
    <FormControl sx={{ m: 1, minWidth: 160, width: "95%" }} size="small">
      <Autocomplete
        multiple
        id="tags-standard"
        options={queryFilter}
        disableCloseOnSelect={true}
        groupBy={(option) => option?.category ?? ""}
        getOptionLabel={(option) => option?.value ?? ""}
        defaultValue={defaultValue}
        onChange={(event, newValue) => handleChange(newValue)}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="standard"
            label="Filter"
            placeholder="Select filter"
          />
        )}
      />
    </FormControl>
  );
};

export default ComboBoxQuery;
